import { gql } from '~/src/generated/portal/gql';

const GET_TEST_PLAN = gql(`
  query apiTestPlan($id: String!) {
    apiTestPlan(id: $id) {
      id
      name
      description
      partnerId
      created
      providerId
      partner {
        id
        name
        languages
        workstreams
        confluenceName
      }
      status
      testSetInstanceIds
      platform {
        platform
      }
      minApiVersion {
        version
      }
      environment
      publishedStatus
      executionStatus {
        status
        lastRun
        certifiedAt
        certifiedBy {
          firstName
          lastName
          id
          email
          partnerWorkstreams {
            partnerId
            workstreams
            partner {
              id
              name
              languages
              workstreams
              confluenceName
            }
          }
          profileName
        }
      }
      testSetInstances {
        id
        testSetId
        name
        description
        note
        executionStatus {
          status
          lastRun
        }
        partnerId
        testPlanId
        testInstances {
          id
          testId
          name
          description
          validationEnabled
          category
          displayId
          requireFreshSubscription
          labels{
            label
          }
          lastRunTestInfo {
            id
            partnerId
            testId
            testInstanceId
            testName
            testPlanId
            testSetInstanceId
            result
            subjectId
            entitlementId
            notes
            fileReference
            startTime
            endTime
            validationNotes
            validationWarning
            validationFailureReason
            validationFile
            activationUrl
            issuerName
            issuer {
              id
              activationNotificationEndpoint
              canonicalName
              created
              environment
              issuerName
              linkedProviders{
                id
                displayId
                partnerId
                countryCode
                created
              }
              partnerId
            }
          }
          testPlanRequirements {
            sku
            validateActivationNotification
          }
          testPlanParameters {
            sku
          }
          procedure {
            steps {
              description
              successCriteria
            }
          }
          realtimeValidationRequirements {
            subscriptionInformation
            activationUrl
          }
        }
      }
      activity {
        pk
        sk
        activity {
          ... on TestPlanCreated {
            testPlanId
            createdAt
            createdBy
          }
          ... on TestPlanUpdated {
            testPlanId
            updatedAt
            updatedBy
          }
          ... on TestPlanPublished {
            testPlanId
            publishedAt
            publishedBy
          }
          ... on TestPlanCertified {
            testPlanId
            certifiedAt
            certifiedBy
          }
        }
      }
    }
  }
`);

export default GET_TEST_PLAN;
